<template>
	<div>
		<header-component />
		<b-container>

			<title-component :title="title" :background="background" />

			<b-container class="content-page rounded">
				<b-row class="pb-5">
					<b-col cols="12">
						<p class="p-5">
							Não haveria nome melhor para nossa empresa. Fundada em 1987, a Ação
							Camisetas foi a pioneira no RN em sublimação, proporcionando aos
							nossos clientes e parceiro, a possibilidade de personalizar suas
							camisetas da forma que realmente queriam. <br/><br/>Evoluímos a cada pedido, a
							cada dia, ouvindo o desejo de nossos clientes e sempre investindo no
							que há de mais moderno no nosso seguimento. 30 anos depois, aqui
							estamos! Sempre prontos para atender você, com carinho, agilidade e
							qualidade. Seja bem vindo, seja re-bem vindo a nossa Ação!
						</p>
					</b-col>
					<!-- slides -->
					<b-col cols="12" sm="6" md="3" lg="3" xl="3" class="mb-3">
						<img src="../images/company/setor-criativo-acao-camisetas.png" class="rounded" width="100%" />
					</b-col>
					<b-col cols="12" sm="6" md="3" lg="3" xl="3" class="mb-3">
						<img src="../images/company/setor-impressao-acao-camisetas.png" class="rounded" width="100%" />
					</b-col>
					<b-col cols="12" sm="6" md="3" lg="3" xl="3" class="mb-3">
						<img src="../images/company/setor-serigrafia-acao-camisetas.png" class="rounded" width="100%" />
					</b-col>
					<b-col cols="12" sm="6" md="3" lg="3" xl="3" class="mb-3">
						<img src="../images/company/setor-costura-acao-camisetas.png" class="rounded" width="100%" />
					</b-col>
					<!-- objectives -->
					<b-col class="mt-5" md="4">
						<h2>missão</h2>
						<div class="border-warning mx-auto"></div>
						<p class="text-center p-2">
							Proporcionar aos clientes a melhor experiência de personalização de
							roupas, com agilidade e preço justo, entregando produtos de alta
							qualidade e transformando os clientes em nossos amigos.
						</p>
					</b-col>
					<b-col class="mt-5" md="4">
						<h2>visão</h2>
						<div class="border-warning mx-auto"></div>
						<p class="text-center p-2">
							Ser a marca de camisetas e abadás personalizados mais bem
							conceituada do nordeste.
						</p>
					</b-col>
					<b-col class="mt-5" md="4">
						<h2>valores</h2>
						<div class="border-warning mx-auto"></div>
						<p class="text-center p-2">
							- Proximidade com o cliente<br />
							- Qualidade<br />
							- Comprometimento<br />
							- Respeito<br />
							- Ética<br />
							- Transparência
						</p>
					</b-col>
				</b-row>
			</b-container>

		</b-container>
		<footer-component />
	</div>
</template>

<style scoped>
h2 {
	font-size: 20px;
	font-weight: 700;
	text-transform: uppercase;
	text-align: center;
}

.bg-slide {
	min-height: 250px;
	background-size: cover;
	background-position: 50%;
}
</style>

<script>
import Background from "@/images/backgrounds/header-page.png"

import HeaderComponent from "@/components/Header"
import FooterComponent from "@/components/Footer"
import TitleComponent from "@/components/Title"
export default {
	data() {
		return {
			title: "Sobre",
			background: Background,
		}
	},
	components: {
		HeaderComponent,
		FooterComponent,
		TitleComponent
	}
}
</script>
